import { Observable } from 'rxjs';
import { AbstractSpaceClass } from './space/abstract-space.class';
import { DataObject } from './data-object.models';

export enum ConversionType {
  TenancyToNrs = 'tenancy-to-nrs',
  TenancyToTenancy = 'tenancy-to-tenancy',
  AvailabilityToTenancy = 'availability-to-tenancy',
  TenancyToAvailability = 'tenancy-to-availability',
  NrsToAvailability = 'nrs-to-availability',
}

export interface EfficiencyTransport<T extends AbstractSpaceClass = AbstractSpaceClass> {
  /** Space to be replaced. It should extend from the {@link AbstractSpaceClass} */
  space?: T;
  floor?: string;
  propertyId?: number;
  usage?: string;
  /**
   * this attribute allows the app to identify what type of space conversion we
   * are making.
   * @see ConversionType
   */
  conversionType?: ConversionType;
  /**
   * HTTP prepared request to create a space. It is an attribute commonly used
   * to create a NRS, as its creation process is driven by the stacking plan
   * library.
   */
  createSpaceRequest$?: Observable<any>;
  /**
   * HTTP prepared request to close a space. It is an attribute commonly used
   * to close a NRS, as its creation process is driven by the stacking plan
   * library.
   */
  closeSpaceRequest$?: Observable<any>;
  remainingSpace?: number;
  remainingSpaceUOM?: string;
  originalSpace?: number;
  originalSpaceUOM?: string;
  // ATTRIBUTES USED TO CREATE A RECORD/SPACE
  /**
   * This attribute must be used only to create a record and must not be used
   * to replace a space.
   */
  entityName?: string;
  /**
   * This attribute must be used only to create a record and must not be used
   * to replace a space.
   * Use {@link EfficiencyTransport.space} when replacing a space
   */
  suiteNumber?: string;
  containerRecordFloors?: DataObject[];
  ownerOccupied?: boolean;
}

export interface ReplaceSpaceEvent {
  floor?: string;
  suiteNumber?: string;
  propertyId: number;
  tenantId?: number;
  currentCompanyName?: string;
  leaseId?: number;
  availabilityId?: number;
  usage?: string;
  createSpaceRequest$?: Observable<any>;
  closeSpaceRequest$?: Observable<any>;
  remainingSpace?: number;
  remainingSpaceUOM?: string;
  originalSpace?: number;
  originalSpaceUOM?: string;
  entityName?: string;
  ownerOccupied?: boolean;
  conversionType?: ConversionType;
  isTenancy?: boolean;
  containerRecordFloors?: DataObject[];
}

export type CreateSpaceEvent = Pick<
  ReplaceSpaceEvent,
  | 'floor'
  | 'suiteNumber'
  | 'propertyId'
  | 'usage'
  | 'entityName'
  | 'createSpaceRequest$'
  | 'remainingSpace'
  | 'remainingSpaceUOM'
  | 'originalSpace'
  | 'originalSpaceUOM'
  | 'containerRecordFloors'
  | 'ownerOccupied'
>;

export type ReplaceSpaceAction<T extends ReplaceSpaceEvent> = (replaceTenancyEvent: T) => Observable<any>;
